import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

const ApproveSignupModal = ({ open, signup, onClose, onConfirm, isLoading = false }) => {
  if (!signup) {
    return null;
  }

  const orgName = signup.organization_name || signup.email;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Approve organization?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          <strong>{orgName}</strong> will be activated and gain access to the enabled features.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? 'Approving…' : 'Approve'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveSignupModal;
